<template>
  <div class="container">
    <!-- Header -->
    <Header></Header>
    <div class="detail-container">
      <div class="head-cate">
<!--        <span>全部文章</span>-->
<!--        <span>公司动态</span>-->
<!--        <span>媒体报道</span>-->
      </div>
      <div class="detail-head">
        <div class="detail-name">{{newsInfo.name}}</div>
        <div class="detail-author">
<!--          <span>发表作者{{newsInfo.author}}</span>-->
<!--          <span>标签：{{newsInfo.lable}}</span>-->
          <span>{{newsInfo.addTime}}</span>
        </div>
      </div>
      <div class="detail-img"><img :src="newsInfo.img"></div>
      <div class="detail-context" v-html="newsInfo.context"></div>
    </div>
    <!-- Footer -->
    <Footer></Footer>
  </div>
</template>

<script>
import axios from 'axios'
var CONFIG = require('@/common/config.js')
var base_url = CONFIG.API_URL.BASE_URL
var img_url = CONFIG.API_URL.IMG_URL;
export default {
  data () {
    return {
      base_url: base_url, // base_url
      id: 0, // 资讯id
      newsInfo: []// 资讯信息
    }
  },
  created: function () {
    var that = this

    // 获取资讯详情
    that.getNewsInfo()
  },
  watch: {
    $route: function () {
      var that = this
      // 获取资讯详情
      that.getNewsInfo()
    }
  },
  methods: {
    // 获取资讯详情
    getNewsInfo: function () {
      var that = this
      // 页面携带参数
      var id = that.$route.query.id
      that.id = id
      axios.post(base_url + 'front/getInfoDetail', {'id': id}).then(function (res) {
        console.log(res)
        if (res.data.code == 0) {
          var dataInfo = res.data.result
          var arrInfo = []
          arrInfo['name'] = dataInfo['title']
          arrInfo['img'] = img_url + dataInfo['imgUrl']
          arrInfo['addTime'] = dataInfo['addTime'].substr(0, 4) + '年' + dataInfo['addTime'].substr(5, 2) + '月' + dataInfo['addTime'].substr(8, 2) + '日'
          arrInfo['context'] = dataInfo['content']
          that.newsInfo = arrInfo
        }
      }).catch(function (err) {
        // console.log(err);
      })
    }
  }
}
</script>

<style scoped>
  @import url("./newsDetail.css");
</style>



// WEBPACK FOOTER //
// src/views/newsDetail/newsDetail.vue